"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTE_REGEX = exports.AUTHOR_REGEX = exports.LINE_REGEX = exports.PIPE_REGEX = exports.ESCAPED_COMMA_REGEX = exports.SPACE_REGEX = void 0;
exports.SPACE_REGEX = /\s+/g;
exports.ESCAPED_COMMA_REGEX = /\\,/g;
exports.PIPE_REGEX = /\|/g;
exports.LINE_REGEX = /\r?\n/g;
exports.AUTHOR_REGEX = /(.+)\s*<(.+)>/g;
exports.NOTE_REGEX = /[a-zA-Z0-9]/g;
